import React from 'react';
import { Chip } from '@mui/material';
import { PlanKind, ProjetDessin } from '../../types/projetDessin';

/** Plans techniques — shared bits (Docs/PLANS_TECHNIQUES_PLAN.md). */
export const KIND_TONE: Record<PlanKind, { short: string; color: string }> = {
  pliage: { short: 'Pliage', color: '#1565C0' },
  dxf: { short: 'DXF', color: '#7B1FA2' },
  tournage: { short: 'Tournage', color: '#00796B' },
  usinage: { short: 'Usinage', color: '#B45309' },
  assemblage: { short: 'Assemblage', color: '#2E7D32' },
  autre: { short: 'Document', color: '#616161' },
};

export const PlanKindChip: React.FC<{ kind: PlanKind }> = ({ kind }) => {
  const t = KIND_TONE[kind] || KIND_TONE.autre;
  return <Chip label={t.short} size="small" sx={{ height: 20, fontSize: 11, fontWeight: 700, bgcolor: `${t.color}1A`, color: t.color }} />;
};

const num = (v?: number | string | null) => (v === null || v === undefined || v === '' ? null : Number(v));
const fN = (v: number) => v.toLocaleString('fr-FR', { maximumFractionDigits: 2 });

/** « 12 pièce(s) · Inox 304 · ép. 2 mm » */
export const planMeta = (p: ProjetDessin) =>
  [num(p.quantite) ? `${fN(num(p.quantite)!)} pièce(s)` : '', p.matiere || '', num(p.epaisseur) ? `ép. ${fN(num(p.epaisseur)!)} mm` : '']
    .filter(Boolean).join(' · ');

export const isDxfName = (name?: string | null) => (name || '').toLowerCase().endsWith('.dxf');
export const isPdfFile = (type?: string | null, name?: string | null) =>
  (type || '').toLowerCase() === 'application/pdf' || (name || '').toLowerCase().endsWith('.pdf');
export const isImageFile = (type?: string | null, name?: string | null) =>
  (type || '').toLowerCase().startsWith('image/') || /\.(png|jpe?g|gif|webp)$/i.test(name || '');
